<file-manager [initialPath]="initialPath" [featureKey]="'QUALITY_MANAGEMENT_FILE_MANAGER'"></file-manager>

